import React from 'react'
import Tooltip from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import { getTrans as t } from "../../../../Localization/translations";

function ViewNotification() {
  return (
    <>
{/* <!-- Page Wrapper --> */}
            <div className="page-wrapper">
			
				{/* <!-- Page Content --> */}
                <div className="content container-fluid">

					
					<div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header pb-0">
									<div className="d-lg-flex">
                                        <div>
                                            <span className="mb-0">Select </span> 
                                            <select style={{fontSize:"1.25rem"}} className="form-control" onchange="if (this.value) window.location.href=this.value">
                                                <option value="/monitor" >Generate Bills</option>
                                                <option value="/monitor/generalnotification/" selected>Generate Notifications</option>
                                            </select>		
                                          </div>
									  <div className="ms-auto my-auto mt-lg-0 mt-4">
										<div className="ms-auto my-auto">
										</div>
									  </div>
									</div>
								  </div>
  
                                <div className="card-body">
                                    <div className="success"></div>
                                    <form method="post" action=""> 
									{/* {% csrf_token %} */}
                                        <div className="row">
                                            <div className="col-xl-4">
												<div className="form-group row">
													<label className="col-lg-3 col-form-label">{t('customer')} {t('name')}</label> <Tooltip content="Customer Name"><i  className="fa fa-light fa-circle-info"></i></Tooltip>
													<div className="col-lg-9">
														<select required name="customer_id" id="customer_list" className="form-control input-lg" data-live-search="true" title="Select Customer">
	
                                                        </select>  
                                                        <input type="hidden" id="contract_status" value="" />
                                                        <input type="hidden" id="processing_type" value="notification" />
													</div>
												</div>
											</div>
                                            <div className="col-xl-4">
												<div className="form-group row">
													<label className="col-lg-3 col-form-label">{t('through')} {t('date')}</label> <Tooltip content="Through Date"><i  className="fa fa-light fa-circle-info"></i></Tooltip>
													<div className="col-lg-9">
                                                        {/* {% now "d/m/Y" as todays_date %} */}
                                                        <input type="text" className="bdatepick form-control " name="start_date" id="startdate"/>
                                                    </div>
												</div>
											</div>
                                            <div className="col-xl-4">
												<div className="form-group row">
													<div className="col-lg-12 text-center" style={{marginTop:"30px"}}>
                                                        <button type="button" className="requestNotification btn bg-gradient-secondary ms-auto mb-0">Save</button>&nbsp;&nbsp;
                                                        <button type="button" className="refreshRequest btn bg-gradient-secondary ms-auto mb-0">Refresh</button>&nbsp;&nbsp;

                                                    </div>
												</div>
											</div>
										</div>							
                                    </form>
                                        </div>
                                </div>
                                <div className="row" id="payschedule" style={{marginTop:"10px"}}>
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="table-responsive">
                                                <table id="tasks foo" className="table table-nowrap mb-0" > {/*id="foo"*/}
                                                    <thead>
                                                        <th>Request ID</th>
                                                        <th>Process Name</th>
                                                        <th>Request Date</th>                                                        
                                                        <th>Status</th>
                                                    </thead>
                                                    <tbody>
                                                    {/* {% for row in bgrequest %} */}
                                                    <tr id="bg_{{row.id}}">
                                                        <td>
															{/* {{row.id}} */}
															</td>
                                                        <td>
															{/* {{row.process_name}} */}
															</td>
                                                        <td>
															{/* {{row.request_date | date:'m/d/Y'}} */}
															</td>
                                                        <td>
															{/* {{row.status | title}} */}
															</td>
                                                       </tr>
                                                    {/* {% endfor %} */}
                                                    </tbody>
                                                </table>
                                                </div>
                                                
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                       
        {/* </form>			 */}
            </div>
			{/* <!-- /Page Wrapper --> */}
        </div>
		
        
		
		
		

		
    </>
  )
}

export default ViewNotification
